import React from "react";
import { Building2 } from "lucide-react";
import SchoolProfileForm from "../schools/SchoolProfileForm";
import { Button } from "../ui";
import Card from "../ui/Card";
import {
  FieldHint,
  FORM_STYLE_CARD_CLASS,
  FormValidationAlert,
  SectionTitle,
} from "../createEvent/CreateEventFormUi";
import HostOnboardingStickyActions, {
  ONBOARDING_DESKTOP_ACTIONS,
} from "./HostOnboardingStickyActions";

const FORM_ID = "host-onboarding-school-form";

/**
 * School branch — name + city required. Sticky create CTA on mobile.
 */
export default function HostOnboardingSchoolStep({
  school,
  onSchoolChange,
  fieldErrors,
  cityPlaceholder,
  saving,
  onBack,
  onSubmit,
}) {
  const errorCount = Object.keys(fieldErrors || {}).length;
  const createLabel = saving ? "Creating…" : "Create school →";

  return (
    <>
      <form
        id={FORM_ID}
        className="space-y-5"
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
        noValidate
        aria-busy={saving}
        data-testid="host-onboarding-school-form"
      >
        <FormValidationAlert count={errorCount} />

        <Card className={FORM_STYLE_CARD_CLASS}>
          <SectionTitle icon={Building2}>School details</SectionTitle>
          <FieldHint className="text-[13px]">
            Name and city now. Bio and socials can wait.
          </FieldHint>
          <SchoolProfileForm
            values={school}
            onChange={onSchoolChange}
            errors={{
              name: fieldErrors.school_name || fieldErrors.name,
              city: fieldErrors.school_city || fieldErrors.city,
            }}
            cityPlaceholder={cityPlaceholder}
            nameTestId="host-onboarding-school-name"
            cityTestId="host-onboarding-school-city"
            bioTestId="host-onboarding-school-bio"
            instagramTestId="host-onboarding-school-instagram"
            whatsappTestId="host-onboarding-school-whatsapp"
          />
        </Card>

        <div className={ONBOARDING_DESKTOP_ACTIONS}>
          <Button
            type="button"
            variant="secondary"
            onClick={onBack}
            disabled={saving}
            data-testid="host-onboarding-school-back"
          >
            ← Back
          </Button>
          <Button
            type="submit"
            variant="primary"
            size="lg"
            disabled={saving}
            data-testid="host-onboarding-school-save"
          >
            {createLabel}
          </Button>
        </div>
      </form>

      <HostOnboardingStickyActions testId="host-onboarding-school-sticky">
        <Button
          type="button"
          variant="secondary"
          disabled={saving}
          onClick={onBack}
          className="shrink-0 px-3"
          data-testid="host-onboarding-school-back-sticky"
        >
          Back
        </Button>
        <Button
          type="submit"
          form={FORM_ID}
          variant="primary"
          size="lg"
          disabled={saving}
          className="flex-1 min-w-0"
          data-testid="host-onboarding-school-save-sticky"
        >
          <span className="truncate">{createLabel}</span>
        </Button>
      </HostOnboardingStickyActions>
    </>
  );
}
